import { SET_STATICBLOCK_LIST } from "../actions";

const staticblock = (state = [], action) => {
  switch (action.type) {
    case SET_STATICBLOCK_LIST:
      return [...action.value];
    default:
      return state;
  }
};

export default staticblock;
